export default __webpack_public_path__ + "static/media/Poppins.7a1a8382.woff2";